module.exports = __webpack_public_path__ + "static/media/loup.9a0252ba.svg";